module.exports = __webpack_public_path__ + "img/map-marker-stop.e245d4eb.svg";